import React, {useEffect, useMemo, useState} from "react";
import {ClayToggle} from "@clayui/form";
import {useTranslation} from "react-i18next";
import {fetchCurrentCartData, getInsuranceCarts, getInsurances} from "../../util/Api";
import InsuranceSelect from "../InsuranceSelect";
import {InsuranceCartsContext} from "../../util/Context";

export default function GreenCycleToggle() {
    const {t} = useTranslation();
    const [showGreenCycleParts, setShowGreenCycleParts] = useState(false);
    const [insuranceId, setInsuranceId] = useState(0);
    const [insurances, setInsurances] = useState([]);
    const [insurancesLoading, setInsurancesLoading] = useState(false);
    const [insuranceCarts, setInsuranceCarts] = useState([]);
    const [insuranceCartsLoading, setInsuranceCartsLoading] = useState(false);
    const [currentCart, setCurrentCart] = useState(null);

    const onNewCartAdded = () => {
        reloadInsuranceCarts();
        reloadCurrentCart();
    }

    // This is buggy for the moment and cases a lot of network calls (kind of recurrence loop)
    // Liferay.after('current-order-updated', (event) => {
    //     onNewCartAdded();
    // });

    function reloadCurrentCart() {
        setInsurancesLoading(true);
        fetchCurrentCartData()
            .then(json => {
                setCurrentCart(json)
            })
            .catch(error => alert(t("an-unexpected-error-occurred")))
            .finally(() => setInsurancesLoading(false));
    }

    function reloadInsuranceCarts() {
        setInsuranceCartsLoading(true);
        getInsuranceCarts(insuranceId, window?.Liferay?.CommerceContext?.account?.accountId)
            .then(json => setInsuranceCarts(json))
            .catch(error => alert(t("an-unexpected-error-occurred")))
            .finally(() => setInsuranceCartsLoading(false));
    }

    useEffect(() => {
        setInsurancesLoading(true);
        getInsurances()
            .then(json => setInsurances(json))
            .catch(error => alert(t("an-unexpected-error-occurred")))
            .finally(() => setInsurancesLoading(false));
    }, []);

    useEffect(() => {
        if(showGreenCycleParts) {
            reloadCurrentCart();
        }
    }, [showGreenCycleParts]);

    useEffect(() => {
        if(currentCart?.customFields?.insurance) {
            setInsuranceId(currentCart.customFields.insurance);
        }
    }, [currentCart])

    useEffect(() => {
        if(showGreenCycleParts) {
            reloadInsuranceCarts();
        }
    }, [insuranceId, showGreenCycleParts]);

    const contextValue = useMemo(() => ({
        onNewCartAdded: onNewCartAdded,
        insuranceCarts: insuranceCarts,
        insuranceCartsLoading: insuranceCartsLoading,
        currentCartId: currentCart?.id,
        currentCartName: currentCart?.customFields?.insuranceCaseNumber
    }), [insuranceCarts, insuranceCartsLoading, currentCart?.id, currentCart?.customFields?.insuranceCaseNumber]);

    if (insurances.length === 0) {
        console.debug(
            "%c[DEBUG] InsuranceSelect: Not a customer in an insurance company. The button is not displayed.",
            "color: orange; font-weight: bold;"
        );
    }

    if(insurances?.length === 0) {return null;}
    return (
        <div
            className="green-cycle-toggle-wrapper mt-3"
            style={{"--toggle-margin": showGreenCycleParts ? "0" : "0.5rem"}}
        >
            <div className="green-cycle-toggle-switch">
                <ClayToggle label={t("show-green-cycle-parts")} onChange={() => setShowGreenCycleParts(prev => !prev)}/>
            </div>
            {showGreenCycleParts && (
                <InsuranceCartsContext.Provider value={contextValue}>
                    <InsuranceSelect insurances={insurances} insurancesLoading={insurancesLoading}
                                     insuranceId={insuranceId}
                                     setInsuranceId={setInsuranceId}/>
                </InsuranceCartsContext.Provider>
            )}
        </div>
    )
}